import { defineComponent } from "vue";
import type { IProviderImportStepProps } from "../types/stepProps";
import { ConnectionLoader } from "../components/connection-loader";

export const ConnectingStep = defineComponent<IProviderImportStepProps>((props) => {
  return () => {
    return <ConnectionLoader hook={props.hook} progress={props.hook.refreshProviderImportProgress}/>
  }
}, { props: ['hook'] });
